/**
 * Parse ConfigCat RPT_PROMOTION_FALL_SALE__ENDS_AT (Unix seconds) to ms.
 * Shared by marketing gate and createRPTCampaign so both accept the same values.
 *
 * @param {unknown} endsAtSeconds
 * @returns {number|undefined} Unix milliseconds, or undefined if unset/invalid
 */
export function parseConfigCatEndsAtMs(endsAtSeconds) {
  const seconds = Number(endsAtSeconds)
  if (!Number.isSafeInteger(seconds) || seconds <= 0) {
    return undefined
  }

  const milliseconds = seconds * 1000
  if (!Number.isSafeInteger(milliseconds) || !Number.isFinite(new Date(milliseconds).getTime())) {
    return undefined
  }

  return milliseconds
}
